/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usage_Overage_Set_Exact_InlineInputs */



/**
* | output |
* | --- |
* | "or set exact:" |
*
* @param {Usage_Overage_Set_Exact_InlineInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const usage_overage_set_exact_inline = /** @type {((inputs?: Usage_Overage_Set_Exact_InlineInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_Overage_Set_Exact_InlineInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("oder genauer Wert:")
	return /** @type {LocalizedString} */ ("or set exact:")
});